import { render } from "./CollectionIndex.vue?vue&type=template&id=72029f9f"
import script from "./CollectionIndex.vue?vue&type=script&lang=js"
export * from "./CollectionIndex.vue?vue&type=script&lang=js"
script.render = render

export default script